import type { NotificationContext } from 'src/apis/notification-service/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const notificationsContextLabels: Record<NotificationContext, string> = {
  ASSIGNMENTS: 'Assignments',
  LNG_MARKETING: 'LNG',
};

export const notificationsContextValues = labelsToValues(
  notificationsContextLabels
);
export const notificationsContextOptions = labelsToOptions(
  notificationsContextLabels
);
